<template>
  <div style="height: 100%;">
    <page v-if="ready"/>
    <div v-else class="loader">Loading...</div>
  </div>
</template>

<script>
import page from "@/components/page";
import { mapActions } from "vuex";
import { localize } from 'vee-validate'

export default {
  data () {
    return {
      ready: false,
      meta: []
    };
  },
  components: {
    page
  },
  mounted () {
    /**
     * Check the campaign ending date, and if its true,
     * redirect to 'campaign-is-over' page
     */
    const endDate = new Date(this.$store.state.campaignEndDate).toLocaleString('en-US', { timeZone: 'Europe/Berlin' });
    const currentTime = new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' });
    const dayInSeconds = 86400; // If we need to include the ending day
    if ((new Date(endDate).getTime()/1000 + dayInSeconds) < (new Date(currentTime).getTime()/1000)) {
      this.goToPage('over', this)
      setTimeout(() => {
        window.location = 'https://oralb-testen.de/'
      }, 300000)
    }
    /**
     * Enable cookie banner after page loaded
     */
    window.addEventListener('load', () => {
      setTimeout(() => {
        this.addCssStyle('#onetrust-consent-sdk {display:block}')
      }, 3000)
    })
  },
  async created () {
    const acceptedCountries = ['se' , 'fi', 'dk', 'no']
    const localLanguage = localStorage.getItem('lang')
    let countryCode;

    // const url = process.env.VUE_APP_SITE_URL || window.location.host;
    const pageProperties = this.$store.state.pageProperties;
    const dictionary = pageProperties.dictionary;
    if (dictionary) {
      // merges with built-in phrases
      localize(dictionary);
    }
    if (process.env.NODE_ENV === "development") {
      pageProperties.testing = true;
    } else {
      pageProperties.testing = false;
    }

    // this.getTemplateData(url).then(pageProperties => {
    if (pageProperties == "GEOLIMIT") {
      this.$router.push("/geoLimit");
      // this.ready=true;
      return;
    }

    if (pageProperties == "NOT_FOUND" || !pageProperties.pages) {
      this.$router.push("/");
      // this.ready=true;
      return;
    }

    /**
     * Check if given url pathname is in pages database and its public,
     * otherwise redirect to 404
     */
    const pathIsEmpty = this._.isEmpty(this.$route.params);
    if (!pathIsEmpty && this.$route.params) {
      let path = this.$route.params.pathMatch;
      if (path.includes("/")) { // Check if url has language code
        let queryStringLanguage = path.split("/")[0]
        if (acceptedCountries.includes(queryStringLanguage)) {
          localStorage.setItem('lang', queryStringLanguage) // Set the language
          this.$root.$i18n.locale = queryStringLanguage
          countryCode = queryStringLanguage
        }
        path = path.split("/")[1]
      } else {
        if (!localLanguage) {
          this.checkGeoLocation().then(country => {
            if (acceptedCountries.includes(country)) {
              localStorage.setItem('lang', country)
              this.$root.$i18n.locale = country
              countryCode = country
            }
          })
        } else {
          if (acceptedCountries.includes(path)) {
            localStorage.setItem('lang', path)
            this.$root.$i18n.locale = path
            countryCode = path
          } else {
            countryCode = localLanguage
          }
        }
      }
      this.locale = countryCode
      this.$store.commit("setCampaignId", `oralb-moneyback-${countryCode}`)
      if (!path || acceptedCountries.includes(path)) history.replaceState({}, null, `/${countryCode}/`);
      else {
        this.isPublic(path).then(pageIsPublic => {
          if (pageIsPublic) {
            this.goToPage(path, this);
          } else {
            history.replaceState({}, null, `/${countryCode}/`);
          }
          if (!pageProperties.pages.find(page => page.pageName === path)) {
            this.goToPage('404', this);
          }
        });
      }
    }
    if (
      pageProperties.header &&
      pageProperties.header.properties.font
    ) {
      this.addCssFile(pageProperties.header.properties.font.url);
      this.setGlobalFont(
        pageProperties.header.properties.font.name
      );
    }
    if (
      pageProperties.header &&
      pageProperties.header.properties.customJsInjection
    ) {
      const customJs =
        pageProperties.header.properties.customJsInjection;
      customJs.forEach(jsCfg => {
        this.injectJs(jsCfg);
      });
    }
    if (pageProperties.header && pageProperties.header.properties.gdpr) {
      const gdprConfig = pageProperties.header.properties.gdpr;
      this.addJsFile(gdprConfig.url);
    }
    if (
      pageProperties.header &&
      pageProperties.header.properties.dataLayer
    ) {
      const GTMConfig = pageProperties.header.properties.dataLayer;
      this.addGTM(GTMConfig);
    }
    if (
      pageProperties.header &&
      pageProperties.header.properties.neustar
    ) {
      const neustarConfig =
        pageProperties.header.properties.neustar;
      this.addNeustar(neustarConfig);
    }
    if (
      pageProperties.header &&
      pageProperties.header.properties.facebookPixel
    ) {
      const facebookConfig =
        pageProperties.header.properties.facebookPixel;
      this.addFacebookPixel(facebookConfig);
    }

    if (
      pageProperties.header &&
      pageProperties.header.properties.chat
    ) {
      const chat = pageProperties.header.properties.chat;
      if (chat.control) {
        this.addHTML(chat.control);
      }
      if (chat.js) {
        this.addJsFile(chat.js);
      }
      if (chat.css) {
        this.addCssFile(chat.css);
      }
    }

    if (
      pageProperties.header &&
      pageProperties.header.properties.meta
    ) {
      const meta = pageProperties.header.properties.meta;
      if (meta) {
        this.meta = meta;
      }
    }

    this.ready = true;
    document.dispatchEvent(new Event("x-app-rendered"));
    // });
  },
  methods: {
    ...mapActions(["getTemplateData", "isPublic", "checkGeoLocation", "refreshTempId", "setCampaignId"]),

    addCssStyle (styles) {
      const style = document.createElement("style");
      style.type = "text/css";
      style.innerHTML = styles;
      document.getElementsByTagName("head")[0].appendChild(style);
    },
    addCssFile (url) {
      const link = document.createElement("link");
      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = url;
      document.getElementsByTagName("head")[0].appendChild(link);
    },
    addJsFile (url) {
      let script = document.createElement("script");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("charset", "UTF-8");
      script.setAttribute("src", url);
      document.head.appendChild(script);
    },
    addHTML (html) {
      document.body.insertAdjacentHTML("beforeend", html);
    },
    setGlobalFont (font) {
      document.body.style.fontFamily = font;
    },
    addNeustar (cfg) {
      let N = document.createElement("script");
      N.setAttribute("type", "text/javascript");
      N.setAttribute("charset", "UTF-8");
      N.textContent = `   window.nsIdPending = false;
        function OptanonWrapper() {
          Optanon.OnConsentChanged(()=>{
          if(!window.nsId && !window.nsIdPending ){
              window.nsIdPending = true;
          fetchJsonp('${cfg.url}', {
                  jsonpCallbackFunction: 'neustar_response'
              })
              .then(function(response) {
                  return response.json()
              }).then(function(json) {
                  window.nsId = json.nsid
              })

          if (window._agknEchoTag) {
                  var a = window._agknEchoTag;
                  a.setBpId('firstp');
                  a.addEchoKeyValue('event', 'page_landing');
                  a.generateTag();
              }}
              })
      }`;
      document.head.appendChild(N);
    },
    injectJs (cfg) {
      let tag = document.createElement("script");
      tag.setAttribute("type", "text/javascript");
      tag.setAttribute("charset", "UTF-8");
      tag.textContent = cfg.content;
      if (cfg.location === "body") document.body.append(tag);
      else document.head.appendChild(tag);
      console.log("inject", tag);
    },
    addFacebookPixel (cfg) {
      let fbF = document.createElement("script");
      fbF.setAttribute("type", "text/javascript");
      fbF.setAttribute("charset", "UTF-8");
      fbF.textContent = `    !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '${cfg.init}');
  fbq('track', 'PageView');
  `;
      document.head.appendChild(fbF);
      let fbNs = document.createElement("noscript");
      fbNs.textContent = `<img height="1" width="1" style="display:none" src="${cfg.noscript}" alt=""/>`;
      document.head.appendChild(fbNs);
    },
    addGTM (config) {
      const GTM = config.GTM;
      const GTM_CODE = config.GTM_CODE.toString();
      let GTM_TAG = document.createElement("script");
      GTM_TAG.setAttribute("type", "text/javascript");
      GTM_TAG.setAttribute("charset", "UTF-8");
      GTM_TAG.textContent = `const PGdataLayer ={'GTM':{'SiteLocalContainer':'${GTM.SiteLocalContainer}','FacebookRemarketingID':'${GTM.FacebookRemarketingID}','SiteLocale': 'de-de','SiteTouchpoint': '','SiteCountry': 'DE','SiteBrand': '','SiteLanguage': 'DE','SitePlatform': '','SiteEnvironment': 'Prod','SiteHost': 'CTL','SiteTechnicalAgency': 'Justsnap','SiteStatus': 'Live','GoogleAnalyticsLocal': '${GTM.GoogleAnalyticsLocal}','GoogleAnalyticsBrand': '','GoogleAnalyticsSiteSpeedSampleRate': 'high','GoogleAnalyticsAllowLinker': 'true','GoogleAnalyticsLinkerDomains': '','GoogleAnalyticsEnableOptimizely': 'false','GoogleAnalyticsConsentRequired': 'true','GoogleAnalyticsOptimizeContainerID': '','GoogleAnalyticsReportingView': '','GoogleReCaptcha': 'true', "ConsentOverlay": "${GTM.ConsentOverlay}", "ConsentOverlayID": "${GTM.ConsentOverlayID}","SitePrivacyProtection": "${GTM.SitePrivacyProtection}" }}`;
      let GTM_TAG_FN = document.createElement("script");
      GTM_TAG_FN.setAttribute("type", "text/javascript");
      GTM_TAG_FN.setAttribute("charset", "UTF-8");
      GTM_TAG_FN.textContent = `

       (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
            j.async = true;
            j.src =
                'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', '${GTM_CODE}');
      `;

      document.getElementsByTagName("head")[0].append(GTM_TAG);
      document.getElementsByTagName("head")[0].append(GTM_TAG_FN);
    }
  },
  metaInfo () {
    return {
      meta: this.meta
    };
  }
};
</script>
<style>

/** for chat bot */
#lc.minimized {
  display: none;
}
</style>
<style lang="scss" scoped>
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: 60px auto;
  font-size: 10px;
  position: relative;
  text-indent: -9999em;
  border-top: 1.1em solid rgb(45, 41, 41);
  border-right: 1.1em solid rgb(45, 41, 41);
  border-bottom: 1.1em solid rgb(45, 41, 41);
  border-left: 1.1em solid #ffffff;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 1.1s infinite linear;
  animation: load8 1.1s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
<style lang="scss">
$medium: 992px;
.mobile-hide{
   @media only screen and (max-width: $medium) {
    display: none;
  }
}

</style>
